import { render, staticRenderFns } from "./PayOnWebPopup.vue?vue&type=template&id=d528c0d0"
import script from "./PayOnWebPopup.vue?vue&type=script&lang=js"
export * from "./PayOnWebPopup.vue?vue&type=script&lang=js"
import style0 from "./PayOnWebPopup.vue?vue&type=style&index=0&id=d528c0d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports